import React from 'react';
import { Box, Drawer, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const ITEMS = [
    { label: 'Actual',                 color: '#378ADD', dash: false },
    { label: 'Projection — Holt-Winters', color: '#378ADD', dash: true  },
    { label: 'Green threshold',        color: '#4CAF50', dash: true  },
    { label: 'Red threshold',          color: '#E24B4A', dash: true  },
];

const RAG = [
    { label: 'Green — within target',  bg: '#EAF3DE', border: '#3B6D11', text: '#27500A' },
    { label: 'Amber — near threshold', bg: '#FAEEDA', border: '#854F0B', text: '#633806' },
    { label: 'Red — below target',     bg: '#FCEBEB', border: '#A32D2D', text: '#791F1F' },
];

export default function Beacon4BlendedLegendPanel({ open, onToggle }) {
    return (
        <Drawer
            anchor="right"
            open={open}
            variant="persistent"
            sx={{
                width: open ? 220 : 0,
                flexShrink: 0,
                '& .MuiDrawer-paper': {
                    width:    220,
                    position: 'relative',
                    height:   '100%',
                    border:   'none',
                    borderLeft: '1px solid #e3e8ef',
                    bgcolor:  '#fff',
                    boxShadow: '-2px 0 8px rgba(0,0,0,.06)',
                },
            }}>

            {/* Header */}
            <Box sx={{ px: 2, py: 1.5, borderBottom: '1px solid #e3e8ef', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <Typography sx={{ fontSize: 12, fontWeight: 600, color: '#1a2233', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                    Legend
                </Typography>
                <IconButton size="small" onClick={onToggle} sx={{ color: '#8fa3bc' }}>
                    <CloseIcon sx={{ fontSize: 16 }} />
                </IconButton>
            </Box>

            {/* Chart lines */}
            <Box sx={{ p: 1.5 }}>
                <Typography sx={{ fontSize: 10, fontWeight: 600, color: '#8fa3bc', textTransform: 'uppercase', letterSpacing: '0.06em', px: 0.5, mb: 1 }}>
                    Series
                </Typography>
                {ITEMS.map(item => (
                    <Box key={item.label} sx={{ display: 'flex', alignItems: 'center', gap: 1.25, px: 1.5, py: 0.75, borderRadius: 1 }}>
                        <Box sx={{
                            width: 28, flexShrink: 0,
                            height: item.dash ? 0 : 3,
                            borderRadius: 1,
                            bgcolor: item.dash ? 'transparent' : item.color,
                            borderTop: item.dash ? `2.5px dashed ${item.color}` : 'none',
                        }} />
                        <Typography sx={{ fontSize: 12, color: '#1a2233' }}>
                            {item.label}
                        </Typography>
                    </Box>
                ))}
            </Box>

            <Box sx={{ height: '1px', bgcolor: '#e3e8ef', mx: 1.5 }} />

            {/* RAG badges */}
            <Box sx={{ p: 1.5 }}>
                <Typography sx={{ fontSize: 10, fontWeight: 600, color: '#8fa3bc', textTransform: 'uppercase', letterSpacing: '0.06em', px: 0.5, mb: 1 }}>
                    RAG status
                </Typography>
                {RAG.map(r => (
                    <Box key={r.label} sx={{ display: 'flex', alignItems: 'center', gap: 1.25, px: 1.5, py: 0.75, borderRadius: 1 }}>
                        <Box sx={{ width: 14, height: 14, borderRadius: '3px', bgcolor: r.bg, border: `1px solid ${r.border}`, flexShrink: 0 }} />
                        <Typography sx={{ fontSize: 12, color: '#1a2233' }}>
                            {r.label}
                        </Typography>
                    </Box>
                ))}
            </Box>

            <Box sx={{ p: 1.5, mt: 'auto', borderTop: '1px solid #e3e8ef' }}>
                <Typography sx={{ fontSize: 10, color: '#8fa3bc', textAlign: 'center', fontStyle: 'italic' }}>
                    Projection: Holt-Winters
                </Typography>
                <Typography sx={{ fontSize: 10, color: '#8fa3bc', textAlign: 'center' }}>
                    α=0.3 · β=0.1 · γ=0.1
                </Typography>
            </Box>
        </Drawer>
    );
}